import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import ChannelService from '../../services/channel';
import { Channel } from '../../models/channels/types';
import { redirectToLogin } from '../../lib/auth';
import { useEffect } from 'react';
import { AxiosError } from 'axios';

/**
 * Query key for channels data
 */
export const CHANNELS_QUERY_KEY = ['channels'];

/**
 * Fetch all channels from mojo
 *
 * @param options - Optional React Query options
 * @returns Query result with channels data
 */
export const useChannelsQuery = (
  options?: Omit<
    UseQueryOptions<Channel[], Error, Channel[], string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const query = useQuery<Channel[], Error, Channel[], string[]>({
    queryKey: CHANNELS_QUERY_KEY,
    queryFn: async () => {
      const response = await new ChannelService('').fetchAll();
      return response.data.content_channels;
    },
    keepPreviousData: true,
    ...options,
  });

  useEffect(() => {
    if (query.error && query.error instanceof AxiosError) {
      if (
        query.error.response?.status === 401 ||
        query.error.response?.status === 403
      ) {
        redirectToLogin();
      }
    }
  }, [query.error]);
  return query;
};
